import React, { useEffect } from 'react';
import Pager from '../../search/components/Results/Pager';
import ResultsList from '../../search/components/Results/ResultsList';
import { useDispatch, useSelector } from 'react-redux';
import ResultTitle from '../../search/components/Results/ResultTitle';
import { getResults } from '../actions/resultsAction';
import Url from '../helpers/UrlHelper';
import { setPage } from '../actions/searchAction';

const Results = () => {
  const results = useSelector(state => state.results);
  const search = useSelector(state => state.search);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getResults())
  }, [search])

  const onPageChange = (newPage) => {
    dispatch(setPage(newPage));
    Url.setParam('page', newPage)
  }

  return (
    <div className="crtInner has-padding">
      <section className="crtSearchInspiration-results">
        {!results.isLoading && (
          <>
            <ResultTitle results={results} type="inspiration" searchQuery={false} />

            {results.hits &&
              <>
                <ResultsList results={results} />

                <Pager
                  page={results.page}
                  nbPages={results.nbPages}
                  onPageChange={onPageChange}
                />
              </>
            }
          </>
        )}
      </section>
    </div>
  );
};

export default Results;
